import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FacetSummary, FiltersModel, FiltersModelPartialHelper } from 'src/app/shared/models/filters';
import { ResizeService } from 'src/app/shared/services/resize/resize.service';
import { SelectedGeolocation, SessionConstants } from '../../models/v2/search';
import { Params, Router } from '@angular/router';
import { InstanceService } from '@commonspirit/ngx-instance';
import { ConfigurationKey } from 'src/app/core/models/configuration-key';
import { FalUrlBuilder } from 'src/app/core/util/url/fal-url-builder';
import { EnvValue } from '@commonspirit/ngx-environment/lib/models/key-value-pair';
import { EnvironmentService } from '@commonspirit/ngx-environment';

@Component({
  selector: 'fal-lite-filters',
  templateUrl: './fal-lite-filters.component.html',
  styleUrls: ['./fal-lite-filters.component.scss']
})
export class FalLiteFiltersComponent implements OnInit {
  @Input() selectedLocation!: SelectedGeolocation;
  @Input() filtersModel!: FiltersModel;
  @Input() showOnlineBookingFilter = false;
  @Input() bookingOnlineFilterDisplayText = '';
  @Input() showServicesAvailableFilter = false;
  @Input() servicesAvailableFilterDisplayText = '';
  @Input() showAcceptingNewPatientsFilter = false;
  @Input() acceptingNewPatientsFilterDisplayText = '';
  @Input() showLocationTypeFilter = false;
  @Input() locationTypeFilterDisplayText = '';
  @Input() showSearchRadiusFilter = false;
  @Input() searchRadiusFilterDisplayText = '';
  @Input() showOpenNowFilter = false;
  @Input() openNowFilterDisplayText = '';
  @Input() showCityFilter = false;
  @Input() cityFilterDisplayText = '';
  @Input() isLocationSelected = false;
  @Input() defaultSearchDistance: number | undefined = 0;
  @Input() showLandingFilters = true;
  @Output() filtersModelChange = new EventEmitter<FiltersModel>();
  public filterKeys: { key: number; value: number }[];

  @Input() showRadiusCloseIcon = false;
  showModalSelectedRadius = false;
  landingFilterConfig = ConfigurationKey.LandingFilters;
  landingFilters: any = [];
  specialtyLandingFilter: any = [];
  locationTypeLandingFilter: any = [];
  enableBlockIT = false;

  get isDesktopViewport(): boolean {
    return this.resizeService.isDesktopViewport;
  }

  get defaultDisplayRadiusKey(): number | undefined {
    return FiltersModelPartialHelper.getRadiusKeyForDistance(this.defaultSearchDistance);
  }
  get displayRadius(): number | undefined {
    return FiltersModelPartialHelper.getDistanceForSearchRadiusKey(this.filtersModel);
  }

  constructor(
    private resizeService: ResizeService,
    public instanceService: InstanceService,
    private urlBuilder: FalUrlBuilder,
    public environmentService: EnvironmentService
  ) {
    this.filterKeys = FiltersModelPartialHelper.radiusValueMapping;
    const enableBlockITForEnvironment: EnvValue | undefined = this.environmentService.getSetting('enableBlockIT')?.value;
    if (typeof enableBlockITForEnvironment === 'boolean') {
      this.enableBlockIT = enableBlockITForEnvironment;
    }
  }
  ngOnInit(): void {
    let landingFilters =
      (this.instanceService.getConfiguration(this.landingFilterConfig)?.value as {
        displayText?: string;
        enabled: boolean;
        value?: string;
        type?: string;
        enableBlockIT?: boolean;
      }[]) ?? [];
    landingFilters = landingFilters.filter((x) => x.enableBlockIT === this.enableBlockIT);
    console.log(landingFilters);
    landingFilters.forEach((element) => {
      if (element.type === 'Speciality' && element.enabled === true) {
        this.specialtyLandingFilter.push(element);
      }
      if (element.type === 'LocationType' && element.enabled === true) {
        this.locationTypeLandingFilter.push(element);
      }
    });
  }

  toggleSpecialty(specialty: FacetSummary): void {
    FiltersModelPartialHelper.SpecialityToggle(specialty, this.filtersModel);
  }

  checkSpecialty(specialty: FacetSummary): boolean {
    return this.filtersModel.selectedSpecialties.map((n) => n.name?.toLowerCase()).includes(specialty.name?.toLowerCase());
  }

  handleFilterChange($event: any): void {
    this.filtersModelChange.emit(this.filtersModel);
  }

  handleFilterSpecialties(filteringActive: boolean): void {
    this.filtersModel.servicesAvailableApplied = filteringActive
      ? this.filtersModel.servicesAvailableToggle
      : (this.filtersModel.servicesAvailableToggle = false);
    if (!filteringActive) {
      this.filtersModel.selectedSpecialties = [];
      window.sessionStorage.setItem(SessionConstants.SelectedSpecialtiesFilter, '[]');
    } else {
      this.filtersModel.selectedSpecialties = [...this.filtersModel.selectedSpecialties];
      FiltersModelPartialHelper.setSpecialties(this.filtersModel.selectedSpecialties);
      this.clearOtherFilters('locationType');
    }
    this.filtersModel.servicesAvailableApplied = this.filtersModel.selectedSpecialties.length > 0;
    this.filtersModelChange.emit(this.filtersModel);
  }

  clearOtherFilters(filterType: string): void {
    switch (filterType) {
      case 'locationType': {
        const sessionValue = window.sessionStorage.getItem(SessionConstants.SelectedLocationTypesFilter);
        if (!sessionValue || sessionValue === '[]') {
          this.filtersModel.selectedLocationTypes = [];
        }
        break;
      }
      case 'specialties': {
        const sessionValue = window.sessionStorage.getItem(SessionConstants.SelectedSpecialtiesFilter);
        if (!sessionValue || sessionValue === '[]') {
          this.filtersModel.selectedSpecialties = [];
        }
        break;
      }
    }
  }

  toggleLocationType(locationType: FacetSummary): void {
    FiltersModelPartialHelper.LocationTypeToggle(locationType, this.filtersModel);
  }

  checkLocationType(locationType: FacetSummary): boolean {
    return this.filtersModel.selectedLocationTypes.map((n) => n.name?.toLowerCase()).includes(locationType.name?.toLowerCase());
  }

  filterLocationTypes(filteringActive: boolean): void {
    this.filtersModel.locationTypeApplied = filteringActive
      ? this.filtersModel.locationTypeToggle
      : (this.filtersModel.locationTypeToggle = false);
    if (!filteringActive) {
      this.filtersModel.selectedLocationTypes = [];
      window.sessionStorage.setItem(SessionConstants.SelectedLocationTypesFilter, '[]');
    } else {
      this.filtersModel.selectedLocationTypes = [...this.filtersModel.selectedLocationTypes];
      FiltersModelPartialHelper.setLocationTypes(this.filtersModel.selectedLocationTypes);
      this.clearOtherFilters('specialties');
    }
    this.filtersModel.locationTypeApplied = this.filtersModel.selectedLocationTypes.length > 0;
    this.filtersModelChange.emit(this.filtersModel);
  }

  initializeSpecialtyDialog(): void {
    if (this.filtersModel) {
      this.filtersModel.selectedSpecialties = [...this.filtersModel.selectedSpecialties];
    }
  }

  initializeLocationTypeDialog(): void {
    if (this.filtersModel) {
      this.filtersModel.selectedLocationTypes = [...this.filtersModel.selectedLocationTypes];
    }
  }

  handleSearchRadiusChange(event: any): void {
    this.showRadiusCloseIcon = this.filtersModel.searchRadius != this.defaultDisplayRadiusKey;
    this.filtersModel.locationSearchRadius = FiltersModelPartialHelper.getDistanceForSearchRadiusKey(this.filtersModel);
    this.filtersModelChange.emit(this.filtersModel);
  }

  clearRadiusFilter(filteringActive: boolean): void {
    this.showRadiusCloseIcon = !this.showRadiusCloseIcon;
    this.filtersModel.searchRadius = this.defaultDisplayRadiusKey;
    this.filtersModel.locationSearchRadius = FiltersModelPartialHelper.getDistanceForSearchRadiusKey(this.filtersModel);
    this.filtersModelChange.emit(this.filtersModel);
  }

  clearSpecialtyFilter(): void {
    this.filtersModel.selectedSpecialties = [];
    window.sessionStorage.setItem(SessionConstants.SelectedSpecialtiesFilter, '[]');
  }

  clearLocationTypeFilter(): void {
    this.filtersModel.selectedLocationTypes = [];
    window.sessionStorage.setItem(SessionConstants.SelectedLocationTypesFilter, '[]');
  }

  landingFilterClicked(val: string, type: string): void {
    let queryString = '';
    const url = this.urlBuilder.searchBuild({
      isService: false,
      searchTerm: null,
      selectedGeolocation: null
    });

    if (type.toLowerCase() === 'speciality') {
      queryString = `?specialties=${val}`;
    } else {
      queryString = `?locationType=${val}`;
    }

    if (location.hostname?.includes('vmfh') && !(location.pathname?.length > 1)) {
      const falPageUrl = this.instanceService.getConfiguration(ConfigurationKey.FalPage)?.value as { link: string };
      window.location.href = `${falPageUrl.link}` + url + queryString;
    } else {
      window.location.href = location.pathname.replace('/fal-lite', '') + url + queryString;
    }
  }
}
